<gtd-ui-field-default-link
  *ngIf="data?.id; else allAffiliatesTmpl"
  [link]="['/app/affiliates/affiliates', data?.id]"
  [displayData]="data?.name"
  [relationData]="data?.id"
  [rbacProperty]="RbacPermissionsConstant.WIDGETS_AFFILIATE_PROFILE"
>
</gtd-ui-field-default-link>

<ng-template #allAffiliatesTmpl>
  <div class="d-flex align-items-center">
    <img src="/assets/new-img/flags/all.svg" width="32" height="16" class="mr-8" />
    <span class="text-color text-color--gray" i18n="@@affiliate.all">All Affiliates</span>
  </div>
</ng-template>
